export const adaptKeyShout = (data: IKeyShout): KeyShout => {
	return {
		id: data.id,
		heading: data.heading,
		content: data.content,
		buttonLink: data.button_link,
		image: data.image,
		appLink: data.app_link,
		modalLink: data.modal_link,
		webview: data.webview,
		published: data.published,
		order: data.ordering,
		createdBy: data.created_by
			? {
					id: data.created_by.id,
					firstName: data.created_by.first_name,
					lastName: data.created_by.last_name
				}
			: undefined,
		createdAt: data.created_at,
		updatedAt: data.updated_at
	};
};

export const adaptKeyShouts = (data: IKeyShout[]): KeyShout[] => {
	return data.map(adaptKeyShout);
};
